import { CancelablePromise } from "../cancelablePromise";
import { NATIVESDK_UNDEFINED_MSG } from "./nativeHelpers";
import * as logger from "../logger";


export const OVERLAY_PERMISSION_DENIED = "Overlay permission not granted";
export const OVERLAY_DISPLAY_FAILED = "Overlay display failed";
export function checkOverlayPermission(): CancelablePromise<boolean> {
    return new CancelablePromise<boolean>((resolve, reject) => {
        if (window.geotabModules) {
            try {
                window.geotabModules.systemOverlay.checkPermission(undefined, (err, granted) => {
                    if (granted !== undefined) {
                        resolve(granted);
                    } else {
                        reject(err ?  err : new Error(OVERLAY_PERMISSION_DENIED));
                    }
                });
            } catch (error) {
                reject(error instanceof Error ? error : new Error(error));
            }
        } else {
            reject(new Error(NATIVESDK_UNDEFINED_MSG));
        }
    });
}

export function requestOverlayPermission(): CancelablePromise<boolean> {
    return new CancelablePromise<boolean>((resolve, reject) => {
        if (window.geotabModules) {
            try {
                window.geotabModules.systemOverlay.requestPermission(undefined, (err, granted) => {
                    if (granted !== undefined) {
                        resolve(granted);
                    } else {
                        reject(err ?  err : new Error(OVERLAY_PERMISSION_DENIED));
                    }
                });
            } catch (error) {
                reject(error instanceof Error ? error : new Error(error));
            }
        } else {
            reject(new Error(NATIVESDK_UNDEFINED_MSG));
        }
    });
}

export function displayOverlay(html: string, chimes?: string, durationInMilliseconds?: number): CancelablePromise<string> {
    return new CancelablePromise<string>((resolve, reject) => {
        if (window.geotabModules) {
            try {
                window.geotabModules.systemOverlay.display({html: html, chimes: chimes, durationInMilliseconds: durationInMilliseconds}, (err, response) => {
                    if (response) {
                        logger.log(logger.Source.NATIVE, `overlay: Displayed successfully with id ${ response } `);
                        resolve(response);
                    } else {
                        logger.error(logger.Source.NATIVE, `overlay: Failed to display ${ err?.message }`);
                        reject(err ?  err : new Error(OVERLAY_DISPLAY_FAILED));
                    }
                });
            } catch (error) {
                reject(error instanceof Error ? error : new Error(error));
            }
        } else {
            reject(new Error(NATIVESDK_UNDEFINED_MSG));
        }
    });
}
